import { MapPin } from "lucide-react";

const footerLinks = [
  {
    title: "Tienda",
    links: ["Salsa Macha", "Chapultepín", "Habanero Dorado", "Verde Ancestral"],
  },
  {
    title: "Nosotros",
    links: ["Nuestra Historia", "Contacto"],
  },
  {
    title: "Soporte",
    links: ["Envíos", "Preguntas Frecuentes"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-16 md:py-24 border-t border-white/5"
      style={{ backgroundColor: "#151515" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3
              className="text-2xl font-bold gold-text mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              PURA MADRE
            </h3>
            <p className="text-sm text-[#A3A3A3] leading-relaxed mb-4">
              Salsas artesanales hechas con ingredientes 100% naturales del campo mexicano. Sin conservadores.
            </p>
            <div className="flex items-center gap-2 text-[#E07A5F]">
              <MapPin size={14} />
              <span className="text-xs uppercase tracking-wider">Ciudad de México, México</span>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4
                className="text-sm font-semibold text-[#F5F5F0] uppercase tracking-wider mb-4"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <button
                      className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
                      data-testid={`footer-link-${link.toLowerCase().replace(/\s/g, "-")}`}
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Talavera divider */}
        <div className="talavera-divider mb-8" />

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#A3A3A3]">
            &copy; {new Date().getFullYear()} Pura Madre. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            {["Privacidad", "Términos", "Cookies"].map((item) => (
              <button
                key={item}
                className="text-xs text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
                data-testid={`footer-${item.toLowerCase()}`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
